import React from "react";
import { Navigate } from "react-router-dom";

const UserListComponent = React.lazy(
  () => import("../../../../../components/control-users/components/list/page"),
);
const UserAddComponent = React.lazy(
  () => import("../../../../../components/control-users/components/add/page"),
);

export const userRoutes = [
  {
    path: "list",
    element: <UserListComponent />,
  },
  {
    path: "add",
    element: <UserAddComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/control/users/add" />,
  },
  {
    path: "edit/:id",
    element: <UserAddComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/control/users/list" />,
  },
];
